import { gql, GraphQLClient } from 'graphql-request'
import { Transaction, TransactionType } from '../../types'
import { get } from 'lodash'

const POOL_TRANSACTIONS = gql`
  query transactions($address: String) {
    pools(where: { id: $address }) {
      token0 {
        derivedUSD
      }
      token1 {
        derivedUSD
      }
    }

    mints(first: 100, orderBy: timestamp, orderDirection: desc, where: { pool: $address }) {
      timestamp
      transaction {
        id
      }

      token0 {
        id
        symbol
      }
      token1 {
        id
        symbol
      }
      owner
      sender
      origin
      amount0
      amount1
      amountUSD
    }
    swaps(first: 100, orderBy: timestamp, orderDirection: desc, where: { pool: $address timestamp_gt: 1740758400}) {
      timestamp
      transaction {
        id
      }
      token0 {
        id
        symbol
      }
      token1 {
        id
        symbol
      }
      origin
      amount0
      amount1
      amountUSD
    }
    burns(first: 100, orderBy: timestamp, orderDirection: desc, where: { pool: $address timestamp_gt: 1740758400 }) {
      timestamp
      transaction {
        id
      }
      token0 {
        id
        symbol
      }
      token1 {
        id
        symbol
      }
      owner
      origin
      amount0
      amount1
      amountUSD
    }
  }
`

interface TransactionResults {
  pools: {
    token0: {
      derivedUSD: string
    }
    token1: {
      derivedUSD: string
    }
  }[]
  mints: {
    timestamp: string
    transaction: {
      id: string
    }
    token0: {
      id: string
      symbol: string
    }
    token1: {
      id: string
      symbol: string
    }
    origin: string
    amount0: string
    amount1: string
    amountUSD: string
  }[]
  swaps: {
    timestamp: string
    transaction: {
      id: string
    }
    token0: {
      id: string
      symbol: string
    }
    token1: {
      id: string
      symbol: string
    }
    origin: string
    amount0: string
    amount1: string
    amountUSD: string
  }[]
  burns: {
    timestamp: string
    transaction: {
      id: string
    }
    token0: {
      id: string
      symbol: string
    }
    token1: {
      id: string
      symbol: string
    }
    owner: string
    origin: string
    amount0: string
    amount1: string
    amountUSD: string
  }[]
}

export async function fetchPoolTransactions(
  address: string,
  client: GraphQLClient,
): Promise<{ data: Transaction[] | undefined; error: boolean }> {
  try {
    const data = await client.request<TransactionResults>(POOL_TRANSACTIONS, {
      address: address.toLocaleLowerCase(),
    })

    const token0USDPrice = get(data, 'pools[0].token0.derivedUSD')
    const token1USDPrice = get(data, 'pools[0].token1.derivedUSD')

    const getAmountUSD = (m: any) => {
      return parseFloat(m.amountUSD) === 0
        ? Math.abs(parseFloat(m.amount0)) * (token0USDPrice || 0) +
            Math.abs(parseFloat(m.amount1)) * (token1USDPrice || 0)
        : parseFloat(m.amountUSD)
    }

    const mints = data.mints.map((m) => {
      return {
        type: TransactionType.MINT,
        hash: m.transaction.id,
        timestamp: m.timestamp,
        sender: m.origin,
        token0Symbol: m.token0.symbol,
        token1Symbol: m.token1.symbol,
        token0Address: m.token0.id,
        token1Address: m.token1.id,
        amountUSD: getAmountUSD(m),
        amountToken0: parseFloat(m.amount0),
        amountToken1: parseFloat(m.amount1),
      }
    })
    const burns = data.burns.map((m) => {
      return {
        type: TransactionType.BURN,
        hash: m.transaction.id,
        timestamp: m.timestamp,
        sender: m.origin,
        token0Symbol: m.token0.symbol,
        token1Symbol: m.token1.symbol,
        token0Address: m.token0.id,
        token1Address: m.token1.id,
        amountUSD: getAmountUSD(m),
        amountToken0: parseFloat(m.amount0),
        amountToken1: parseFloat(m.amount1),
      }
    })

    const swaps = data.swaps.map((m) => {
      return {
        type: TransactionType.SWAP,
        hash: m.transaction.id,
        timestamp: m.timestamp,
        sender: m.origin,
        token0Symbol: m.token0.symbol,
        token1Symbol: m.token1.symbol,
        token0Address: m.token0.id,
        token1Address: m.token1.id,
        amountUSD: getAmountUSD(m),
        amountToken0: parseFloat(m.amount0),
        amountToken1: parseFloat(m.amount1),
      }
    })
    console.log('mints', mints, 'burns', burns, 'swaps', swaps)

    return { data: [...mints, ...burns, ...swaps], error: false }
  } catch (e) {
    console.error(e)
    return { data: undefined, error: true }
  }
}
